import { AlertTriangle, RefreshCw } from "lucide-react";

interface Props {
  onRegenerate?: () => void;
}

export function OutOfSyncBadge({ onRegenerate }: Props) {
  return (
    <div className="inline-flex items-center gap-1.5">
      <span
        className="inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800 dark:bg-amber-900/30 dark:text-amber-300"
        title="This artefact was generated against a previous blueprint version"
      >
        <AlertTriangle size={10} />
        Out of sync
      </span>
      {onRegenerate && (
        <button
          type="button"
          onClick={onRegenerate}
          className="inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-xs text-text-muted hover:bg-card-hover"
          title="Regenerate against the current locked blueprint version"
        >
          <RefreshCw size={10} />
          Regenerate
        </button>
      )}
    </div>
  );
}
